import React, { Component } from "react";
import { Modal } from "antd-mobile";
import { isDesktopBrowser } from '../../pages/download/pcFrame';
import DesktopModal from './DesktopModal';
import styles from './styles.module.scss';

class DownloadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brandName: "hw" // 华为 oppo vivo 小米 魅族 其他安装后
    };
  }

  setBrandName = (name) => {
    this.setState({ brandName: name });
  };

  handleDownload = (e) => {
    const { onClose } = this.props;
    if (onClose) onClose();
  };

  render() {
    const { visible } = this.props;
    if (isDesktopBrowser(window.navigator)) {
      return visible ? <DesktopModal onClose={this.handleDownload}>{this.renderContent()}</DesktopModal> : null;
    }
    return (
      <Modal
        popup
        className={styles.downloadModal}
        visible={visible}
        onClose={this.handleDownload}
        animationType="slide-up"
      >
        {this.renderContent()}
      </Modal>
    );
  }

  renderContent() {
    const { modalDownloadUrl } = this.props;
    const { brandName } = this.state;
    return (
      <>
        <h3>Android安装教程</h3>
        <p>APP安装后若出现问题，查看相关教程</p>
        <ul className="brand-list">
          <li
            className={brandName === "hw" ? "active" : ""}
            onClick={() => this.setBrandName("hw")}
          >
            华为
          </li>
          <li
            className={brandName === "oppo" ? "active" : ""}
            onClick={() => this.setBrandName("oppo")}
          >
            OPPO
          </li>
          <li
            className={brandName === "vivo" ? "active" : ""}
            onClick={() => this.setBrandName("vivo")}
          >
            VIVO
          </li>
          <li
            className={brandName === "xiaomi" ? "active" : ""}
            onClick={() => this.setBrandName("xiaomi")}
          >
            小米
          </li>
          <li
            className={brandName === "meizu" ? "active" : ""}
            onClick={() => this.setBrandName("meizu")}
          >
            魅族
          </li>
          <li
            className={brandName === "other" ? "active" : ""}
            onClick={() => this.setBrandName("other")}
          >
            安装后
          </li>
        </ul>
        {brandName === "hw" && (
          <>
            {/* <div className="step-box">
              <div className="step step01">
                <h4>安装教程</h4>
                <p>安装时提示“安全提醒”, 无法安装</p>
              </div>
              <div className="bg_img hw_img01"></div>
            </div> */}
           
            <div className="bg_img hw_img01"></div>
            <div className="bg_img hw_img02"></div>
            <div className="bg_img hw_img03"></div>
          </>
        )}
        {brandName === "oppo" && (
          <>
            <div className="bg_img oppo_img01"></div>
            <div className="bg_img oppo_img02"></div>
          </>
        )}
        {brandName === "vivo" && (
          <>
            <div className="bg_img vivo_img01"></div>
            <div className="bg_img vivo_img02"></div>
          </>
        )}
        {brandName === "xiaomi" && (
          <>
            <div className="bg_img xiaomi_img01"></div>
          </>
        )}
        {brandName === "meizu" && (
          <>
            <div className="bg_img meizu_img01"></div>
          </>
        )}
        {brandName === "other" && (
          <>
            <div className="bg_img other_img01"></div>
            <div className="bg_img other_img02"></div>
          </>
        )}
        <a
          download
          rel="noopener noreferrer"
          href={modalDownloadUrl}
          className="btn"
          onClick={this.handleDownload}
        >
          立即下载
          <span className="label" />
        </a>
      </>
    );
  }
}

export default DownloadModal;
